import { getUrl } from '@muse-web/url'

import { ANONYMOUS_USERNAME, definedParams, getAuthorPageUrl } from '@core/routes'

export const getAuthorCollectionsPageUrl = ({
    authorUsername,
}: {
    authorUsername: string
}): string =>
    authorUsername === ANONYMOUS_USERNAME
        ? '/'
        : `${getAuthorPageUrl({ authorUsername })}/collections`

// Owner-only tabs that still live on the current site — reachable by hard navigation only. The guard
// matters: `getAuthorPageUrl` collapses a missing username to `/`, which would make `//projects` — a
// protocol-relative URL pointing at another host.
const authorSubPageUrl = (authorUsername: string, path: string): string =>
    !authorUsername || authorUsername === ANONYMOUS_USERNAME
        ? '/'
        : `${getAuthorPageUrl({ authorUsername })}/${path}`

export const getAuthorProjectsPageUrl = ({ authorUsername }: { authorUsername: string }): string =>
    authorSubPageUrl(authorUsername, 'projects')

export const getAuthorInsightsPageUrl = ({ username }: { username: string }): string =>
    authorSubPageUrl(username, 'insights')

export const getAuthorPromoPagesPageUrl = ({
    authorUsername,
}: {
    authorUsername: string
}): string => authorSubPageUrl(authorUsername, 'promo-pages')

export type TGetAuthorAudioListUrlParams = {
    authorUsername: string
    sort?: string
    page?: number
}

// Defaults are dropped before `getUrl` sees them: the backend 301s `?page=1` to the clean URL, and the
// sort default is implicit. Same rule as `getSearchUrl`.
export const getAuthorAudioListUrl = ({
    authorUsername,
    sort,
    page,
}: TGetAuthorAudioListUrlParams): string =>
    getUrl({
        url: getAuthorPageUrl({ authorUsername }),
        params: definedParams({
            sort: sort && sort !== 'newest' ? sort : undefined,
            page: page && page > 1 ? page : undefined,
        }),
    })

export const getAuthorCollectionsListUrl = ({
    authorUsername,
    page,
}: {
    authorUsername: string
    page?: number
}): string =>
    getUrl({
        url: getAuthorCollectionsPageUrl({ authorUsername }),
        params: definedParams({ page: page && page > 1 ? page : undefined }),
    })
